module.exports = __webpack_public_path__ + "img/voto.b82dce5c.png";